import { css } from 'styled-components'

import mq from '../../utils/mediaQuery'

const btnStyle = css`
  min-width: 180px;
  ${mq.mobile} {
    min-width: 0;
    padding: 0 16px;
  }
  @media (max-width: 360px) {
    padding: 0 12px;
  }
`
export { btnStyle }
